export default __webpack_public_path__ + "static/media/13-460x460.c92b33b4.jpeg";